import { render, staticRenderFns } from "./NavigationLinkByDesign.vue?vue&type=template&id=4e2d3a84"
import script from "./NavigationLinkByDesign.vue?vue&type=script&lang=ts"
export * from "./NavigationLinkByDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports